import $api from '../../utils/api.js'


const state = () => ({
    settings: [],
    sorting: {
        search: '',
        type: '',
        group: '',
        sort:'asc',
        placeholder:'Search Settings'
    },
    formdata:{
        id:'',
        key:'',
        display_name:'',
        value:'',
        details:'',
        type:'',
        group:'',
        image_url:'',
    },
    errors:[],
})

const mutations = {
    ASSIGN_DATA(state, payload) {
        state.settings = payload
    },
    ASSIGN_FORM(state, payload) {
        state.formdata = {
            id:payload.id,
            key:payload.key,
            display_name:payload.display_name,
            value:payload.value,
            details:payload.details,
            type:payload.type,
            group:payload.group,
            image_url:payload.image_url,
        }
    },
    CLEAR_FORM(state) {
        state.formdata = {
            id:'',
            key:'',
            display_name:'',
            value:'',
            details:'',
            type:'',
            group:'',
            image_url:'',
        },
        state.errors = []
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
}

const actions = {
    getSettings({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`web-config?search=${state.sorting.search}&sort=${state.sorting.sort}&group=${state.sorting.group}&type=${state.sorting.type}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createSettings({ commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`web-config`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    editSettings({ commit }, payload) {
        return new Promise((resolve) => {
            $api.get(`web-config?&id=${payload}`)
            .then((response) => {
                commit('ASSIGN_FORM', response.data)
                resolve(response.data)
            })
        })
    },
    updateSettings({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.post(`web-config/${state.formdata.id}`, payload.formData)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },
    deleteSettings({ dispatch }, payload) {
        return new Promise((resolve) => {
            $api.delete(`web-config/${payload}`)
            .then(() => {
                dispatch('getSettings').then(() => resolve())
            })
        })
    },
    
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}